import api from "PFCore/api";
import { ActivityEvent, Id, PaginatedCollection, QueryParams } from "PFTypes";

export type FetchActivityHistoryParams = QueryParams &
  Partial<{
    sortBy: string;
    eventType: string[];
    operatorId: Id[];
    createdAtMin: string | null;
    createdAtMax: string | null;
  }>;

export type ActivityHistoryProfile = {
  id: number;
  firstName?: string;
  lastName?: string;
  status: "active" | "inactive";
  suspendedAt?: string | null;
};
export type FetchActivityHistoryResponse = PaginatedCollection<
  ActivityEvent[],
  {
    profiles: Record<number, ActivityHistoryProfile>;
    availableEventTypes: string[];
    availableOperatorIds: Id[];
  }
>;

export const fetchActivityHistory = (activityId: Id, params: FetchActivityHistoryParams) =>
  api<FetchActivityHistoryResponse>({
    url: `activities/${activityId}/history`,
    params
  });
